import { normalizeBudget } from "./normalizeBudget";

export const formatBudgetAmount = (budgetdata) => {
  const budget = normalizeBudget(budgetdata);

  // Rule 1: Explicitly not specified or to be discussed
  if (!budget.currency || budget.discloseBudget === true) {
    return "To be Discussed";
  }

  // Check for min and max amounts (budget range)
  if (budget.minAmount && budget.maxAmount) {
    const minAmt = Number(budget.minAmount);
    const maxAmt = Number(budget.maxAmount);

    if (!Number.isNaN(minAmt) && !Number.isNaN(maxAmt)) {
      const formatter = new Intl.NumberFormat(
        budget.currency.locales || "en-IN",
        {
          style: "currency",
          currency: budget.currency.value,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );
      return `${formatter.format(minAmt)} - ${formatter.format(maxAmt)}`;
    }
  }

  // Handle single amount
  if (!budget.amount) {
    return "To be Discussed";
  }

  const amount = Number(budget.amount);

  if (Number.isNaN(amount)) {
    return "Not Specified";
  }

  // Rule 2: Proper formatting
  return new Intl.NumberFormat(
    budget.currency.locales || "en-IN",
    {
      style: "currency",
      currency: budget.currency.value,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  ).format(amount);
};



// import { normalizeBudget } from "./normalizeBudget";

// export const formatBudgetAmount = (budgetdata) => {
//   const budget = normalizeBudget(budgetdata);

//   // Rule 1: Explicitly not specified or to be discussed
//   if (!budget.amount || !budget.currency || budget.discloseBudget === true) {
//     return "To be Discussed";
//   }

//   const amount = Number(budget.amount);

//   if (Number.isNaN(amount)) {
//     return "Not Specified";
//   }

//   // Rule 2: Proper formatting
//   return new Intl.NumberFormat(
//     budget.currency.locales || "en-IN",
//     {
//       style: "currency",
//       currency: budget.currency.value,
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }
//   ).format(amount);
// };
